import Mock from "../../assests/mock.png";
// import logo from "../../assests/white logo-reaidy.png";
import React, { useEffect, useState } from "react";
import { FaCircleNotch } from "react-icons/fa";
import { apiGet, apiPostPut } from "../../api/api_methods";
import { getMockTestApplicants } from "../../api/recruiterAssessmentsApi";
import { RECRUITER_ASSESSMENTS_AVAILABLE_CATEGORIES } from "../../api/endpoints";
import { useLocation, useNavigate } from "react-router-dom";
import { useStores } from "../../store";
import Loader from "../reusble_components/loader";
import { loginWarningImage } from "../../helpers/constantVariables";
import Popup from "../reusble_components/popup";
import { setDataToLocalStorage } from "../../services/localStorage";
import { getLogoBySubdomain } from "../../services/white_label";
import SelectWithDropDown from "../JobPost/selectWithDropDown";
export default function CreateMockTest() {
  const location = useLocation();
  const [load, setLoad] = useState();
  const queryParams = new URLSearchParams(location.search);
  const topic = queryParams.get("topic");
  const que = queryParams.get("que");
  const id = queryParams.get("mocktestId");
  const recruiterId = queryParams.get("recruiterId");
  const applicationId = queryParams.get("applicationId");
  const [topicName, setTopicName] = useState("");
  const [questions, setQuestions] = useState("");

  const [branch, setBranch] = useState(topic ? topic : "");
  const [edit, setEdit] = useState(que ? true : false);
  const [loader, setLoader] = useState(false);
  const [numberOfQuestions, setNumberOfQuestions] = useState(que ? que : "");
  const navigate = useNavigate();
  const { MockStore, PopupStore } = useStores();
  const [options, setOptions] = useState([]);
  const [hasRun, setHasRun] = useState(false);
  const [mock, setMock] = useState();
  const [topicError, setTopicError] = useState(false);
  const [questionError, setQuestionError] = useState("");
  const getoptions = async () => {
    const res = await apiGet(RECRUITER_ASSESSMENTS_AVAILABLE_CATEGORIES);
    if (res.status === 200 && res.body?.success) {
      setOptions(res.body.data || []);
      // if (res.body.data.length > 0) {
      //   setBranch(res.body.data[0]);
      // }
    }
  };
  const handleSetBranch = (e) => {
    setBranch(e.target.value);
  };
  useEffect(() => {
    // console.log("hello");

    console.log(topic, que);
    setTopicName(topic);
    setQuestions(que);
    if (topic || que) {
      getoptions();
    }
  }, [topic, que]);
  useEffect(() => {
    if (id) {
      getTopic();
    }
  }, [id]);
  useEffect(() => {
    // console.log("hello");

    console.log(topic, que);

    getoptions();
  }, [topic, que]);
  const getTopic = async () => {
    setLoad(true);
    const res = await getMockTestApplicants(id, {});
    if (res.status === 200 || res.status === 201) {
      const data = res.body?.data?.invitation ?? res.body?.data;
      if (data) {
        setLoad(false);
        setEdit(true);
        setTopicName(data.mockTestName);
        setMock(data);
        if (!JSON.parse(localStorage.getItem("user"))?._id) {
          PopupStore.setLoginWarning(true);
        }
        if (data.noOfQuestions) {
          setNumberOfQuestions(data.noOfQuestions);
        } else {
          setNumberOfQuestions(
            (data.noOfAptitudeQuestions ?? 0) +
              (data.noOfReasoningQuestions ?? 0) +
              (data.noOfTechnicalQuestions ?? 0) +
              (data.noOfVerbalQuestions ?? 0),
          );
        }
      }
    }
    setLoad(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (!branch) {
    //   alert("Please select the branch");
    //   return;
    // }
    const userId = JSON.parse(localStorage.getItem("user"))?._id;
    if (!userId) {
      PopupStore.setLoginWarning(true);
      return;
    }
    if (numberOfQuestions < 20) {
      alert("Minimum 20 questions are required");
      return;
    }
    setLoader(true);
    let res;
    if (id) {
      // Validate attempts before starting the test
      const validationRes = await MockStore.validateMcqAttempts(id);
      if (validationRes.status !== 200 || !validationRes.body?.success) {
        alert(
          validationRes.body?.message ||
            "You have reached the maximum number of attempts for this test.",
        );
        setLoader(false);
        return;
      }

      res = await MockStore.getMcqsWithSameQuestion(userId, id);
    } else {
      res = await MockStore.getMcqs(
        topicName ? topicName : branch,
        numberOfQuestions,
        mock?.noOfAptitudeQuestions,
        mock?.noOfReasoningQuestions,
        mock?.noOfTechnicalQuestions,
        mock?.noOfVerbalQuestions,
      );
    }
    if (res.status === 200) {
      MockStore.setQuestion();
      setLoader(false);
      MockStore.setTestOnLive(true);
      localStorage.setItem("branch", topicName ? topicName : branch);
      // localStorage.setItem("que", numberOfQuestions);
      // console.log("success");
      // console.log("Aptitude", MockStore.aptitude);
      // console.log("Reasoning", MockStore.reasonong);
      // console.log("Verbal", MockStore.verbals);
      // console.log("Core", MockStore.core);
      if (applicationId) {
        navigate(
          `/mock?invitationId=${id}&applicationId=${applicationId}&recruiterId=${recruiterId}`,
        );
      } else if (id) {
        navigate(`/mock?&mocktestId=${id}&recruiterId=${recruiterId}`);
      } else {
        navigate("/mock");
      }
    } else {
      setLoader(false);
    }
  };
  const redirectToSignupPageWithCurrentUrl = () => {
    const currentPath = window.location.href;

    // set currentPath in local storage
    setDataToLocalStorage("redirectUrl", currentPath);

    const signupUrl = `/`;

    console.log(signupUrl);

    navigate(signupUrl);
  };
  return (
    <>
      {PopupStore.loginWarning && (
        <Popup
          popUpInitialValue={PopupStore.loginWarning}
          handlePopup={() => {
            PopupStore.setLoginWarning(false);
          }}
          image={loginWarningImage}
          content="Please signup to start Mock Test"
          buttontext="Signup now"
          onClick={() => {
            redirectToSignupPageWithCurrentUrl();
            PopupStore.setLoginWarning(false);
          }}
        />
      )}
      <div className="bg-white m-5 tc8:m-14 h-fit  inset-0 grid  tc8:grid-cols-2 ">
        <Loader loader={load} />
        <div className=" flex flex-col md:mt-0 lg:mt-0 mt-16 justify-center  items-center ">
          <img
            src={getLogoBySubdomain(true)}
            className="w-50 py-8 tc8:hidden  hidden  "
          ></img>
          <img
            src={Mock}
            className="w-[80%] tc8:h-[60%] tc8:w-[60%]  object-cover "
          ></img>
        </div>
        <div className="px-5 py-5 tc8:p-20 lg:pt-44">
          <img
            src={getLogoBySubdomain(true)}
            className="hidden tc8:block tc8:w-56 tc8:py-8 tc8:pl-4 tc11:ml-8 tc12:ml-2 lg:ml-0 tc13:ml-12"
          ></img>
          <h1 className="font-bold text-lg tc8:pl-4 ml-4 tc8:ml-0  tc7:ml-[21%] tc6:ml-[20%] md:ml tc11:ml-8 tc12:ml-2 lg:ml-0 tc13:ml-12">
            Select Your Test
          </h1>
          <form
            onSubmit={handleSubmit}
            className="w-full max-w-md mx-auto lg:mx-0 mt-2 tc8:mt-8"
          >
            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full px-3 tc8:mb-0 ml-3">
                <div className="relative">
                  {id !== null ? (
                    <p className="block appearance-none w-full bg-white text-primary border border-gray-200 py-5 px-2 pr-8 rounded-xl leading-tight focus:outline-none focus:bg-white">
                      {topicName}
                    </p>
                  ) : (
                    <>
                      {/* <select
                      id="branch"
                      className="block appearance-none w-full bg-white text-primary border border-gray-200 py-5 px-2 pr-8 rounded-xl leading-tight focus:outline-none focus:bg-white"
                      onChange={(e) => setBranch(e.target.value)}
                      required
                    >
                      <option value="">Select the Technology</option>
                      {options.map((option, index) => (
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))}
                    </select> */}
                      <SelectWithDropDown
                        placeholder={"Select the Technology"}
                        hideError={true}
                        options={options.map((option, index) => ({
                          label: option,
                          value: option,
                        }))}
                        onError={(e) => setTopicError(true)}
                        action={handleSetBranch}
                        isMcqTestOn={true}
                        required={true}
                      />
                    </>
                  )}

                  <div
                    options={options.map((option, index) => ({
                      label: option,
                      value: option,
                    }))}
                    action={handleSetBranch}
                    isMcqTestOn={true}
                    required={true}
                    className="pointer-events-none cursor-pointer absolute inset-y-0 top-2 right-2 flex items-center px-2 text-primary"
                  >
                    {!id && (
                      <svg
                        className="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M6.293 7.293a1 1 0 0 1 1.414 0L10 9.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 0 1 0-1.414z"
                        />
                      </svg>
                    )}
                  </div>
                </div>
              </div>
              <div className="w-full py-3 md:py-5 px-3 ml-3">
                <input
                  className="block w-full bg-white text-primary placeholder-primary border border-[#c9c9c9] rounded-lg py-5 px-2 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="numberOfQuestions"
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  onInvalid={(e) => {
                    e.preventDefault();
                    e.target.focus();
                    if (e.target.value === "") {
                      setTopicError(true);
                    } else if (e.target.value < 20) {
                      setQuestionError("Minimum 20 questions are required");
                    } else if (e.target.value > 100) {
                      setQuestionError("Maximum 100 questions are allowed");
                    } else {
                      setQuestionError("");
                    }
                  }}
                  max={100}
                  min={20}
                  readOnly={edit}
                  placeholder="Number of questions"
                  value={numberOfQuestions}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d+$/.test(value) || value === "") {
                      setNumberOfQuestions(value);
                    }
                  }}
                  required
                />

                <p className="px-2 opacity-60 text-xs">Min Questions 20</p>
                {topicError && (
                  <p className="px-2 text-red-500 text-xs">
                    Please Fill all the fields
                  </p>
                )}
                {questionError && (
                  <p className="px-2 text-red-500 text-xs">{questionError}</p>
                )}
              </div>
            </div>
            <div className="flex justify-end -mt-3 tc8:mt-0">
              <button
                type="submit"
                className="bg-primary text-white font-bold py-2 px-4 rounded-xl focus:outline-none focus:shadow-outline relative tc6:mb-12 tc3:mb-8"
                style={{ minWidth: "120px" }}
                disabled={loader}
              >
                <span style={{ visibility: loader ? "hidden" : "visible" }}>
                  Start Test
                </span>
                {loader && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <FaCircleNotch className="text-white animate-spin text-2xl" />
                  </div>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
